// Module
var code = `<div class="jumbotron-page style-guide">

  <div class="jumbotron-toolbar">
    <div class="jumbotron-page-heading">
      <span class="jumbotron-title">Style guide</span>
      <span class="jumbotron-subtitle">Every shared element, drawn with the real style</span>
    </div>
  </div>

  <div class="jumbotron-scroll style-guide-scroll">

    <style-guide-sections></style-guide-sections>

  </div>
</div>
`;
// Exports
export default code;